import dayjs from "dayjs";

import { Translation } from "@/data/lang";

import { ULineChartDataInfo } from "ui/analysis/u-line-chart";

import { Top20GraphData } from "../services/get-investor-top20-graph";

type DateUnix = number;
type Price = number;
type Cost = number;
type Top20CostEstimationChartData = [DateUnix[], Price[], Cost[]];

export const getTop20CostEstimationChartData = ({
  data,
}: {
  data?: Top20GraphData[];
}): Top20CostEstimationChartData => {
  const top20GraphData: Top20CostEstimationChartData = [[], [], []];
  if (!data) return top20GraphData;

  return data.reduce((result, { date, closePrice, costPrice }) => {
    if (!date || !closePrice || !costPrice) return result;

    result[0].push(dayjs(date).unix());
    result[1].push(closePrice);
    result[2].push(costPrice);

    return result;
  }, top20GraphData);
};

export const getTop20CostEstimationChartInfo = ({
  t,
}: {
  t: Translation;
}): ULineChartDataInfo[] => [
  {
    label: t.analysis.shared.price,
    strokeColor: "#2D7FAF",
    strokeWidth: 2,
    valueFormatter: (value) => `$${Number(value).toFixed(2)}`,
  },
  {
    label: t.my13F.investor.volumeWeightedEstimatedCosts,
    strokeColor: "#F06C00",
    strokeWidth: 2,
    valueFormatter: (value) => `$${Number(value).toFixed(2)}`,
    tooltipLabel: t.my13F.investor.estimatedCost,
  },
];
